import React from 'react'
import dynamic from 'next/dynamic'

import AbstractLayout from './AbstractLayout'

const Website = dynamic(() => import('./Website'))
const Clean = dynamic(() => import('./Clean'))
const NoWebsite = dynamic(() => import('@page-components/NoWebsite'))

export interface LayoutProps {
  theme?: string
  children: React.ReactNode
  forceLightTheme?: boolean
}

const getLayout = (theme: string) => {
  const layouts = {
    website: Website,
    clean: Clean
  }

  return layouts[theme]
}

/**
 * @deprecated
 * If possible, avoid using this Layout component and use AbstractLayout instead (providing the LayoutComponent prop)
 * It provides faster development and build time.
 * Explanation: Webpack will precompile all nested imports (even for layouts that are not used by the current page).
 * By using AbstractLayout, we can make webpack only precompile the layout that is actually used by the current page.
 */
export default function Layout(props: LayoutProps) {
  const {theme = 'website', forceLightTheme = false, children} = props

  const Component = getLayout(theme)

  return (
    <AbstractLayout
      LayoutComponent={Component}
      forceLightTheme={forceLightTheme}>
      {children}
    </AbstractLayout>
  )
}
